import { Suspense, lazy, useEffect } from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import {
  URL_MARKETPLACE,
  URL_NOT_FOUND,
  URL_EMAIL_VERIFICATION,
  URL_LOGIN,
  URL_REGISTRATION,
  URL_FORGOT_PASSWORD,
  URL_RESET_PASSWORD,
  URL_EMAIL_VERIFICATION_REDIRECT,
} from 'Helpers/urls';
import { PayPalScriptProvider } from '@paypal/react-paypal-js';
import { Auth } from 'Services';

// Custom hooks
import ScrollToTop from 'Hooks/scroll-to-top';
import { AuthProvider, useAuth } from 'Hooks/use-auth';

// Common Layout
import Loader from 'Components/Common/loader';

import PrivateApp from './private';

// Components
const Login = lazy(() => import('../Components/Login'));
const MarketPlace = lazy(() => import('../Components/MarketPlace'));
const NotFound = lazy(() => import('../Components/Pages/not-found'));
const EmailVerification = lazy(() => import('../Components/Pages/email-verification'));
const Registration = lazy(() => import('../Components/Registration'));
const ForgotPassword = lazy(() => import('../Components/ForgotPassword'));
const ResetPassword = lazy(() => import('../Components/ForgotPassword/ResetPassword'));

const App = () => {
  const auth = useAuth();

  useEffect(() => {
    const checkTokenValid = async () => {
      try {
        const res = await Auth.checkTokenValid();
        if (!res.idValidToken) {
          auth.logout();
        }
      } catch (error) {
        console.error(error);
      }
    };

    checkTokenValid();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <MarketPlace path={URL_MARKETPLACE} exact />
        <EmailVerification path={URL_EMAIL_VERIFICATION} exact />
        <Route path={URL_EMAIL_VERIFICATION_REDIRECT} component={EmailVerification} />
        <NotFound path={URL_NOT_FOUND} exact />
        <Login path={URL_LOGIN} exact />
        <Route path={URL_RESET_PASSWORD} exact component={ResetPassword} />
        <ForgotPassword path={URL_FORGOT_PASSWORD} exact />
        <Registration path={URL_REGISTRATION} />
        <PrivateApp />
      </Switch>
    </Suspense>
  );
};

const Routes = () => {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <PayPalScriptProvider options={{ 'client-id': process.env.REACT_APP_PAYPAL_CLIENT_ID, vault: true, intent: 'subscription' }}>
          <App />
        </PayPalScriptProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
